module.exports = __webpack_public_path__ + "static/media/loadingFailed.8b5b113e.jpg";